<!-- display messages -->
<app-messages timeout="0"></app-messages>

<div [ngSwitch]="singleApp">
  <app-room-reservation *ngSwitchCase="'room-reservation'"></app-room-reservation>
  <app-room-info-screen *ngSwitchCase="'room-info-screen'"></app-room-info-screen>
  <ngb-alert [type]="error" *ngSwitchDefault>invalid module: {{ singleApp }}</ngb-alert>
</div>